import { LoaderFunctionArgs, redirect, ShouldRevalidateFunction } from "react-router-dom";
import { backend } from "Backend";
import { AppRoutes } from "AppRoutes";

const getCaseAndLensId = async (args: LoaderFunctionArgs, redirectPath: (lensId: number, id: number) => string) => {
  const clientCaseId = args.params.clientCaseId;

  if (!clientCaseId) {
    return redirect("/lenses");
  }

  const response = await backend.getCaseByClientCaseId(clientCaseId);

  if (!response.case) {
    return redirect("/lenses");
  }

  const { lensId, id } = response.case;
  if (lensId !== undefined && id !== undefined) {
    // continue to destination
    return redirect(redirectPath(lensId, id));
  } else {
    // Backend failed to get a lens id for this case, redirect to lenses
    return redirect("/lenses");
  }
};

export const caseExternalLinkLoader = (args: LoaderFunctionArgs) =>
  getCaseAndLensId(args, (lensId, id) => AppRoutes.caseDetailBuilder(lensId, id));

export const caseDocumentExternalLinkLoader = (args: LoaderFunctionArgs) =>
  getCaseAndLensId(args, (lensId, id) => `/lens/${lensId}/cases/${id}/documents/${args.params.documentId}`);

export const caseDocumentsExternalLinkLoader = (args: LoaderFunctionArgs) =>
  getCaseAndLensId(args, (lensId, id) => `/lens/${lensId}/cases/${id}/documents`);

export const shouldRevalidateDeepLinks: ShouldRevalidateFunction = (params) => {
  const { currentParams, nextParams } = params;
  return currentParams.clientCaseId !== nextParams.clientCaseId;
};
